<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="form">
        <el-form-item label="业务" prop="code">
            <Cascade ref="cascade" v-model="form.code"></Cascade>
        </el-form-item>
        <el-form-item label="类型" prop="type">
            <el-select v-model="form.type" placeholder="请选择">
                <el-option label="短信" value="sms"></el-option>
                <el-option label="彩信" value="mms"></el-option>
                <el-option label="视频短信" value="vms"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="时间范围" prop="times">
            <el-date-picker type="datetimerange" placeholder="选择日期" v-model="form.times"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit('customer')">推送给客户</el-button>
            <el-button type="success" @click="submit('poll')">推送到结果集（轮询）</el-button>
            <el-button @click="reset">取消</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import Cascade from '@/components/Cascade'

    export default {
        components: {
            Cascade,
        },
        data() {
            return {
                form: {
                    code: "",
                    type: "",
                    times: []
                },
                rules: {
                    code: [
                        {required: true, message: '请选择'},
                        {min: 6, message: '请选择具体业务'}
                    ],
                    type: [
                        {required: true, message: '请选择'},
                    ],
                    times: [
                        {required: true, message: '请选择'},
                    ],
                }
            }
        },
        methods: {
            submit(type) {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$axios.post("/pushReport/preExecute/" + this.form.type, {
                            rules: [
                                {"field": "submitTime", "value": this.form.times},
                                {"field": "code", "value": this.form.code}
                            ]
                        }).then(resp => {
                            this.$confirm("此操作将推送" + resp['data'] +"条报告, 是否继续?", '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$axios.post("/pushReport/execute/" + type + "/" + this.form.type, {
                                    rules: [
                                        {"field": "submitTime", "value": this.form.times},
                                        {"field": "code", "value": this.form.code}
                                    ]
                                })
                            });
                        })
                    } else {
                        return false;
                    }
                });
            },
            reset() {
                this.$refs.form.resetFields();
            }
        }
    }
</script>

<style scoped>
    .form {
        width: 600px;
        margin: 100px;
    }
</style>